let MultiStepForm = []

jQuery.getJSON("https://api.ipify.org/?format=json", function (data) {
  localStorage.setItem("ip", data.ip)
})

$(document).ready(function() {
  // Attach a delegated event listener to the parent container of the radio buttons
  $('#form-selector-step-2').on('change', 'input[name="LeadForm[housing_type]"]', function() {
    // Get the selected value
    var selectedValue = $(this).val();
    
    // Store the selected value in localStorage
    localStorage.setItem('selectedHousingType', selectedValue);

    console.log('Stored in localStorage:', selectedValue);
  });

  // On page load or after dynamically loading inputs, pre-select the stored value
  var storedValue = localStorage.getItem('selectedHousingType');
  if (storedValue) {
    $('input[name="LeadForm[housing_type]"][value="' + storedValue + '"]').prop('checked', true);
  }
});

function sendLead(data) {
  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: multiformAjax.ajaxurl,
    data: {
      action: "send_lead",
      data: {
        lastData: JSON.stringify(data),
        // clients info
        ip_address: String(getFromStorage("ip")),
        loan_sum: localStorage.getItem("loan_sum") ?? 200,
        loan_period: localStorage.getItem("loan_period") ?? 91,
        // external params
        transaction_id: getFromStorage("transaction_id"),
        utm_source: getFromStorage("utm_source"),
        utm_medium: getFromStorage("utm_medium"),
        utm_campaign: getFromStorage("utm_campaign"),
        utm_content: getFromStorage("utm_content"),
        utm_term: getFromStorage("utm_term"),
        click_id: getFromStorage("click_id"),
        visitor_id: getFromStorage("visitor_id"),
        tduid: getFromStorage("tduid"),
        gclid: getFromStorage("gclid"),
        google_client_id: getFromStorage("google_client_id"),
        aff_id: getFromStorage("aff_id"),
        recaptcha_response: getFromStorage("recaptcha-response"),
      },
    },
    success: function (response) {
      console.log("response#", response)
      if (response.action && response.action === "moneyman-step" && response.step !== 3){
        setMultiformData(6)
        console.log("TRIGGERED MONEYMAN", response.step)
      }
      else if (response.success) {
        if (response.data == "reCaptcha missing") {
          setMultiformData(1)
        }

        if (response.data?.redirect_url !== "") {
          setTimeout(() => {
            window.location.href = response.data.redirect_url
          }, [200])
        }

        clearAllLocalStorage()
      } else {
        setTimeout(() => {
          window.location.href = multiformAjax.site_url
        }, [200])
      }
    },
  })
}

function recaptchaV2Reset(){
  if( $("#recaptcha-container").length ) { // reset if has container
    grecaptcha.reset()
  }
}

function getActiveRecaptcha(){
  return {
    'v2': isRecaptchaV2Active(),
    'v3': isRecaptchaV3Active()
  }
}

function checkSecurity(data) {
  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: multiformAjax.ajaxurl,
    data: {
      action: "check_form_security",
      data: {
        email: data["LeadForm[email]"],
        ipAddress: localStorage.getItem("ip") ?? "",
        activeRecaptcha: getActiveRecaptcha(),
        recaptchaResponse: data["g-recaptcha-response"],
        recaptchaResponseV3: data["recaptcha-token-v3"],
        utm_source: getFromStorage("utm_source"),
        utm_medium: getFromStorage("utm_medium"),
        utm_campaign: getFromStorage("utm_campaign"),
        utm_content: getFromStorage("utm_content"),
        utm_term: getFromStorage("utm_term"),
      },
    },
    success: function (response) {
      setMultiformData(2, data, "next")
      $('.steps span').removeClass('active');
      $('.steps span:nth-child(3)').addClass('active');
      // if (response.success) {
      //   setTimeout(() => {
      //     setMultiformData(2, data, "next")
      //   }, 200)
      // } else {
      //   if (response.data == "incorrect email") {
      //     showError(1, "email", "correo-electrónico", "invalid")
      //     recaptchaV2Reset()
      //     recaptchaCallback()
      //     jQuery(`#next-btn-loader-step-1`).hide()
      //     jQuery(`#next-btn-content-step-1`).show()
      //   } else if (response.data == "reCaptcha error") {
      //     recaptchaV2Reset()
      //     recaptchaCallback()
      //   }

      //   scrollToErrorElement()
      // }
    },
  })
}

function setMultiformData(step, data, action = null) {
  $('.steps span').removeClass('active');
  $(`.steps span:nth-child(${step + 1})`).addClass('active');
  if (step === 1 && action === 'previous') {
    $('input[type="checkbox"]').each(function() {
      $(this).prop('checked', !$(this).prop('checked'));
    });
  }

  console.log(1, 'step', step, data, action);
  if (data?.['LeadForm[neto_income]'] !== undefined && data?.['LeadForm[monthly_expenses]'] !== undefined) {
    data['LeadForm[neto_income]'] = Math.min(data['LeadForm[neto_income]'], 10000);
    data['LeadForm[monthly_expenses]'] = Math.min(data['LeadForm[monthly_expenses]'], 10000);
  }

  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: multiformAjax.ajaxurl,
    data: {
      action: "set_multiform_data",
      customer_name: step == 2 && action == 'next'
        ? `${data["LeadForm[first_name]"]} ${data["LeadForm[last_name]"]}`
        : null,
      data: JSON.stringify(data),

      // clients info
      ip_address: String(getFromStorage("ip")),
      loan_sum: localStorage.getItem("loan_sum") ?? 200,
      loan_period: localStorage.getItem("loan_period") ?? 91,
      // external params
      transaction_id: getFromStorage("transaction_id"),
      utm_source: getFromStorage("utm_source"),
      utm_medium: getFromStorage("utm_medium"),
      utm_campaign: getFromStorage("utm_campaign"),
      utm_content: getFromStorage("utm_content"),
      utm_term: getFromStorage("utm_term"),
      click_id: getFromStorage("click_id"),
      visitor_id: getFromStorage("visitor_id"),
      tduid: getFromStorage("tduid"),
      gclid: getFromStorage("gclid"),
      google_client_id: getFromStorage("google_client_id"),
      aff_id: getFromStorage("aff_id"),
      step,
    },
    success: function (response) {
      console.log('response', step, response);
      if (step > 1 && action == "next") {
        jQuery(`#next-btn-loader-step-${step - 1}`).hide()
        jQuery(`#next-btn-content-step-${step - 1}`).show()
      }

      if (action == "previous") {
        jQuery(`#prev-btn-loader-step-${step + 1}`).hide()
        jQuery(`#prev-btn-content-step-${step + 1}`).show()
      }

      if (action == "sidebar") {
        jQuery("#sidebar-menu").removeClass("loading")
      }

      document.getElementById("multiform-page").innerHTML = response.data.output
      prefillForm(step)
      updateStepView(step)

      if (step == 1) {
        jQuery(document).ready(function () {
          setTimeout(function () {
            $('input[type="checkbox"]').each(function() {
              $(this).prop('checked', !$(this).prop('checked'));
            });
          }, 1000)
        })
        //jQuery("#LeadForm-phone").inputmask(masks.phone)
        // jQuery("#LeadForm-phone").mask("+34 X00 000 000", {'translation': {
        //     X: {pattern: /[6|7]/}
        //   }
        // })
        jQuery("#LeadForm-personal_code").inputmask(masks.personal_code)
      }

      if (step == 5) {
        jQuery("#LeadForm-bank_account_number").inputmask(
          masks.bank_account_number
        )
      }

      if( step == 2) {
        $('#form-selector-step-2').on('change', 'input[name="LeadForm[housing_type]"]', function() {
          // Get the selected value
          var selectedValue = $(this).val();
          
          // Store the selected value in localStorage
          localStorage.setItem('selectedHousingType', selectedValue);
          console.log('itemstored', localStorage.getItem('selectedHousingType'));
      
          console.log('Stored in localStorage:', selectedValue);
        });

        var storedValue = localStorage.getItem('selectedHousingType');
        if (storedValue) {
          $('input[name="LeadForm[housing_type]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

        dataLayer.push({
          event: "FormCompleted",
          form_name: "contact",
          step: "2",
          name: data['LeadForm[first_name]'],
          surname: data['LeadForm[last_name]'],
          phone: data['LeadForm[phone]'],
          email: data['LeadForm[email]'] ?? ''
        });
      } else if ( step == 3 ) {
        $('.field-LeadForm-gender').on('change', 'input[name="LeadForm[gender]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedGender', selectedValue);
        });

        $('.field-LeadForm-phone_plan').on('change', 'input[name="LeadForm[phone_plan]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedPhonePlan', selectedValue);
          console.log('getPhone', localStorage.getItem('selectedPhonePlan'));
        });

        var storedValue = localStorage.getItem('selectedGender');
        if (storedValue) {
          $('input[name="LeadForm[gender]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

        var storedValue = localStorage.getItem('selectedPhonePlan');
        if (storedValue) {
          $('input[name="LeadForm[phone_plan]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }


        dataLayer.push({
          event: "FormCompleted",
          form_name: "address",
          step: "3",
          name: data['LeadForm[first_name]'],
          surname: data['LeadForm[last_name]'],
          phone: data['LeadForm[phone]'],
          email: data['LeadForm[email]'] ?? '',
          postal_code: data['LeadForm[postal_code]'],
          country: 'spain',
        });
      } else if ( step == 4 ) {
        $('.field-LeadForm-occupation').on('change', 'input[name="LeadForm[occupation]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedOccupation', selectedValue);
        });
        $('.field-LeadForm-car_owner').on('change', 'input[name="LeadForm[car_owner]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedCarOwner', selectedValue);
        });
          $('.field-LeadForm-job_area').on('input', 'input[name="LeadForm[job_area]"]', function() {
            console.log('typed');
            $(this).val($(this).val().replace(/[^0-9]/g, ''));
          });
        

        var storedValue = localStorage.getItem('selectedOccupation');
        if (storedValue) {
          $('input[name="LeadForm[occupation]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

        var storedValue = localStorage.getItem('selectedCarOwner');
        if (storedValue) {
          $('input[name="LeadForm[car_owner]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }
      }
    },
  })
}

function showLoadingScreen(show = true) {
  var loaderContainer = jQuery(".simulador-multistep-loader-container")
  loaderContainer.addClass("show")

  var idx = jQuery(".simulador-multistep-loader-text").data("idx")
  var maxLen = jQuery(".simulador-multistep-loader-text p").length

  if (!show) {
    loaderContainer.removeClass("show")
    return
  }

  var prev = jQuery(`.simulador-multistep-loader-text p:eq("${idx - 1}")`)
  prev.removeClass("show")

  var curr = jQuery(`.simulador-multistep-loader-text p:eq("${idx}")`)
  curr.addClass("show")

  var isLastText = idx >= maxLen - 1
  idx = isLastText ? 0 : idx + 1

  jQuery(".simulador-multistep-loader-text").data("idx", idx)

  var time = [2250, 3000, 2000, 3250, 2500]
  var randomTime = time[Math.floor(Math.random() * time.length)]

  setTimeout(showLoadingScreen, randomTime)
}

window.addEventListener('load', function () {
  var container = jQuery("#form-step-container")
  var step 
  
  if (container) {
    step = container.data("step")
  }
  if (step == 1) {
    // renderRecaptcha()
  }

  if (step) {
    prefillForm(step)
    updateStepView(step)
  }

  //remove below script for old layout
  // Function to format loan sum with thousands separator
  function formatLoanSum(loanSum) {
    return Number(loanSum).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  // Function to update loan value in the DOM
  function updateLoanValue(elementId, value) {
    jQuery("#" + elementId).text(value)
    jQuery(".applying-loan-area").css("display", "flex")
  }

  // Function to handle loan area click event
  function handleLoanAreaClick() {
    jQuery(".loan_modal").addClass("show-loanModal")

    if (loanSum !== null && loanSum !== undefined) {
      var formattedLoanSum = formatLoanSum(loanSum)

      jQuery("#amount_value").text(formattedLoanSum)
      jQuery("#amount_slider").val(loanSum)
    }

    jQuery("html").css("overflow", "hidden")
  }

  // Function to handle close modal click event
  function handleCloseModalClick(event) {
    event.preventDefault(); // Prevent the default behavior of the anchor tag
    jQuery(".loan_modal").removeClass("show-loanModal")

    var updatedLoanValue = jQuery("#amount_slider").val()
    var formattedUpdatedLoanValue = formatLoanSum(updatedLoanValue)

    updateLoanValue("loan__value", formattedUpdatedLoanValue)
    localStorage.setItem("loan_sum", updatedLoanValue)

    jQuery("html").css("overflow", "auto");
  }

  // Main code
  var loanSum = localStorage.getItem("loan_sum") ?? 1500

  if (loanSum !== null && loanSum !== undefined) {
    var formattedLoanSum = formatLoanSum(loanSum)
    updateLoanValue("loan__value", formattedLoanSum)
  }

  jQuery("#loan-area-value").on("click", handleLoanAreaClick)
  jQuery(".close-modal, .close-icon").on("click", handleCloseModalClick)
})
